module.exports = __webpack_public_path__ + "media/images/emblems/Schangnau-coat_of_arms-7f28344e94a5a36adcb47311b73a7260.svg";